var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgObservationPencil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2124 10.9914L19.2983 1.88501C20.3873 0.793537 22.1114 0.793537 23.2005 1.88501C24.2389 2.92578 24.2694 4.64498 23.2687 5.72496C23.2464 5.74906 23.2236 5.77273 23.2005 5.79596L14.4026 14.6137L10.2124 15.4665V10.9914Z",
    stroke: "#3E3D3D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7809 0.0289181C17.6857 0.0099487 17.5872 -6.38779e-08 17.4863 -6.84813e-08L1.50005 -7.98321e-07C0.671625 -8.36142e-07 5.14703e-05 0.671572 5.14356e-05 1.5L5.06237e-05 20.9002C5.0589e-05 21.7286 0.671624 22.4002 1.50005 22.4002L17.4863 22.4002C18.3148 22.4002 18.9863 21.7286 18.9863 20.9002L18.9863 14.3029L17.4863 15.6167L17.4863 20.9002L1.50005 20.9002L1.50005 1.5L16.3113 1.5L17.7809 0.0289181Z",
    fill: "#3E3D3D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObservationPencil);
export default __webpack_public_path__ + "static/media/observationPencil.126d282ab50d5b7af2f9d5fa6b032410.svg";
export { ForwardRef as ReactComponent };